<template>
	<Card>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<DatePicker type="month" placeholder="请选择月份" style="width: 200px" v-model="startTime"
				@on-change="onChangeStart"></DatePicker>
			<Select v-model="shop_id" style="width:150px;margin-left: 20px;" clearable placeholder="跟进分公司" @on-change="shopIdChange">
				<Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-model="follow_department" style="width:150px;margin-left: 20px;" clearable placeholder="跟进团队" @on-change="departmentChange">
				<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-model="follow_uid" style="width:150px;margin-left: 20px;" clearable placeholder="跟进个人" @on-change="getData">
				<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Button @click="initSearch" type="primary" style="margin-left: 20px;">重置刷新</Button>
			<!--span> - </span>
			<DatePicker type="month" placeholder="请选择终止月" style="width: 200px" 
				@on-change="onChangeEnd"></DatePicker-->
		</div>
		<div style="margin-top: 20px;">
			<Table  :columns="columns" :data="data">
				<template slot-scope="{ index,row }" slot="last_repay_money">
					<div v-if="row.last_repay_money < row.repay_money">
						<span
							style="cursor: pointer;">{{row.last_repay_money}}</span><br>
						<span style="color:#ff0000;cursor: pointer;">
							(
							<Icon type="md-arrow-round-up" style="color: red;" />{{row.growth_rate}}
						</span>)
					</div>
					<div v-else-if="row.last_repay_money >= row.repay_money">
						<span
							style="cursor: pointer;">{{row.last_repay_money}}</span><br>
						<span style="color:#00ff00;cursor: pointer;">(
							<Icon type="md-arrow-round-down" style="color:#00ff00;" />{{row.growth_rate}})
						</span>
					</div>
				</template>
			</Table>
		</div>
		<div id="Mimelist2"></div>
	</Card>
</template>

<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getConversion,
		getMonthConversion
	} from "../../api/statics";
	import {getAllShop} from "../../api/runSet";
	import {
		getTeamList,
		getDepartmentList,
		getUserListByDepartmentId,
		getDepartmentListByShopId
	} from '@/api/user'
	export default {
		name: "PublicClientAnalyse",
		data() {
			return {
				client_classify: 2,
				data: [],
				startTime: null,
				endTime: null,
				shop_id:'',
				follow_department:'',
				follow_uid:'',
				columns: [{
						title: '申请时间',
						key: 'name',
						"align": "center",
					},
					{
						title: '创收额',
						key: 'repay_money',
						"align": "center",
					},
					{
						title: '创收占比',
						key: 'rate',
						"align": "center",
					},
					{
						title: '上期创收占比',
						key: 'last_rate',
						"align": "center",
					},
					{
						title: '上月同期',
						slot: 'last_repay_money',
						"align": "center",
					},
				],
				teamList:[],
				departmentList:[],
				shopList:[],
				weekDayList: [],
				yearMonthList: [],
				client_type: '1',
				timePeriod: '0',
				timePeriodDate: [],
				timePeriodList: [{
						value: '0',
						label: '最近7天'
					},
					{
						value: '1',
						label: '最近15天'
					},
					{
						value: '2',
						label: '最近30天'
					},
					{
						value: '3',
						label: '最近1年'
					},
					{
						value: '4',
						label: '最近2年'
					},
				],
				optionMy: {
					tooltip: {
						trigger: 'item',
						formatter: '{b} :  ({d}%)'
					},
					toolbox: {
						show: true,
						feature: {
							mark: {
								show: true
							},
							dataView: {
								show: true,
								readOnly: false
							},
							restore: {
								show: true
							},
							saveAsImage: {
								show: true
							}
						}
					},
					legend: {
						top: 10,
						orient: 'vertical',
						left: 'left',
						data: ['M0', 'M1', 'M2', 'M3以上']
					},
					series: [{
						name: 'Access From',
						type: 'pie',
						radius: '50%',
						label: {
							normal: {
								formatter: '{b}:{c}: ({d}%)',
								textStyle: {
									fontWeight: 'normal',
									fontSize: 15
								}
							}
						},
						data: [{
								value: 0,
								name: 'M0',
							},
							{
								value: 0,
								name: 'M1'
							},
							{
								value: 0,
								name: 'M2'
							},
							{
								value: 0,
								name: 'M3'
							},
							{
								value: 0,
								name: 'M4'
							},
							{
								value: 0,
								name: 'M5+'
							},
						],
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				}


			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getCurrentDate();
			this.getData();
			this.loadData();
		},
		methods: {
			async getData() {
				let that = this;
				let data = {
					startTime: that.startTime,
					shop_id:that.shop_id,
					follow_department:that.follow_department,
					follow_uid:that.follow_uid
				}
				data.token = that.token;
				let res = await getMonthConversion(that, data);
				//如果是一个月
				for (var i = 0; i <= 5; i++) {
					that.optionMy.series[0].data[i].value = res.data.list[i + 1].repay_money;
				}
				let myChart2 = this.$echarts.init(document.getElementById("Mimelist2"));
				myChart2.clear()
				myChart2.setOption(this.optionMy);
				that.data = res.data.list;

			},
			initSearch(){
				
				this.shop_id = '';
				this.follow_department = '';
				this.follow_uid = '';
				this.getData();
				console.log(this.shop_id);
			},
			async departmentChange(){
                let that = this;
                let data = {token: this.token};
                data.departmentId = that.follow_department;
                let res = await getUserListByDepartmentId(that, data);
                if (res.code == 1) {
                    that.teamList = res.data.list;
					
                }		
				this.getData();
			},
			async shopIdChange(){
				let that = this;
				let data = {token: this.token};
				data.shop_id = that.shop_id;
				let res = await getDepartmentListByShopId(that, data);
				if (res.code == 1) {
				    that.departmentList = res.data.list;
					
				}	
				this.getData();				
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				var data = {
					token: that.token,
					getSelf: 1,
				};
				var res = await getTeamList(that, data);
				if (res.code == 1) {
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
			},
			getCurrentDate() {
				var date = new Date();
				var year = date.getFullYear();
				var month = date.getMonth() + 1;
				month = month > 9 ? month : "0" + month;
				var nowMonth = year + "-" + month;
				this.startTime = nowMonth
			},
			onChangeStart(date) {
				console.log(date)
				this.startTime = date;
				this.getData();
			},
			onChangeEnd(date) {
				this.endTime = date;
				this.getData();
			},

			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getData();
			},
			async getList() {
				let that = this;
				let data = {
					timePeriod: this.timePeriod,
					type: that.client_type,
					client_classify: this.client_classify
				}
				data.token = this.token;
				let res = await getConversion(that, data);

				that.optionMy.series[0].data[0].value = res.data.clientNums[0];
				that.optionMy.series[0].data[1].value = res.data.clientNums[1];
				that.optionMy.series[0].data[2].value = res.data.clientNums[2];
				that.optionMy.series[0].data[3].value = res.data.clientNums[3];
				that.optionMy.series[0].data[4].value = res.data.clientNums[4];
				let myChart2 = this.$echarts.init(document.getElementById("Mimelist2"));
				myChart2.clear()
				myChart2.setOption(this.optionMy);
				that.data = res.data.list;
			},
			timePeriodClick(e) {
				this.getList()
			},
		}
	}
</script>

<style scoped lang="less">
	#Mimelist2 {
		width: 100%;
		height: 700px;
		background-color: #FFFFFF;
		padding-top: 30px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}


	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #00aa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}

	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
